<template>
    <div class="layout-2-cols">
        <div class="layout-2-cols__content">
            <slot name="content"></slot>
        </div>
        <div class="layout-2-cols__sidebar-right">
            <slot name="sidebar-right"></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.layout-2-cols {
    max-width: 1200px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: var(--spacing-4);

    &__content {
        grid-column: span 9;
    }

    &__sidebar-right {
        grid-column: span 3;
    }

    @media (width < 1300px) {
        &__content {
            grid-column: span 12;
        }

        &__sidebar-right {
            grid-column: span 12;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: var(--spacing-4);

            :deep(.card-container + .card-container) {
                margin-top: 0;
            }
        }
    }
}
</style>